// Vendor imports
const PropTypes = require('prop-types')
const React = require('react')

class InputText extends React.PureComponent {
  render() {
    const propsWithRef = Object.assign({
      ref: this.props.inputRef
    }, this.props)
    delete propsWithRef.inputRef
    return React.createElement('input', propsWithRef)
  }
}

InputText.propTypes = {
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
}

InputText.defaultProps = {
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: 'false',
  type: 'text'
}

module.exports = InputText
